import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shop_cart_drawer: false,
    loading: false,
    shopcart: [],
    shopcart_message: 0,
    dialog: {
      title: "",
      content: "",
      status: false
    }
  },
  mutations: {
    SetShopCartDrawer(state, action) {
      state.shop_cart_drawer = action
      if (action) {
        document.getElementsByTagName("html")[0].style.overflowY = "hidden"
      } else {
        document.getElementsByTagName("html")[0].style.overflowY = "auto"
      }
    },
    SetPageLoading(state, action) {
      state.loading = action
    },
    SetShopCart(state, data) {
      state.shopcart = data
    },
    SetShopCartMessage(state, count) {
      if (count != 0) {
        state.shopcart_message += count
      } else {
        state.shopcart_message = 0
      }
    },
    SetDialog(state, {
      title,
      content,
      status
    }) {
      state.dialog.title = title
      state.dialog.content = content
      state.dialog.status = status
    }
  },
  actions: {},
  modules: {}
})